
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"19","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"d":"M8.98 5.43a.471.471 0 01.669 0 .477.477 0 010 .672l-8.425 8.464a.952.952 0 00.671 1.627c.251 0 .492-.1.67-.28l8.425-8.464a.471.471 0 01.669 0 .477.477 0 010 .672l-8.424 8.463a1.887 1.887 0 01-2.679.001 1.905 1.905 0 010-2.691L8.98 5.43zM13.95.425a.471.471 0 01.668-.013.477.477 0 01.013.671l-1.84 1.922v1.286h1.327l1.826-1.84a.471.471 0 01.669 0 .477.477 0 010 .672l-1.827 1.84a.943.943 0 01-.668.278H12.79a.948.948 0 01-.946-.95V3.004c0-.246.096-.481.265-.658l1.84-1.921zm1.9 2.557l.87-.373a4.29 4.29 0 01-.904 4.697 4.242 4.242 0 01-4.674.915l.37-.874a3.299 3.299 0 003.635-.712 3.337 3.337 0 00.703-3.653zm-6.1 2.596l-.87.372a4.29 4.29 0 01.903-4.694 4.242 4.242 0 014.67-.918l-.368.875a3.299 3.299 0 00-3.632.714 3.337 3.337 0 00-.703 3.65z","id":"app-maintenance_svg__a"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('use',{attrs:{"fill":"#FFF","fill-rule":"nonzero","xlink:href":"#app-maintenance_svg__a","transform":"translate(.905 .952)"}}),_c('g',{attrs:{"stroke":"#FFF"}},[_c('path',{attrs:{"d":"M11.08 11.802a1.405 1.405 0 000 1.987l3.368 3.367a1.405 1.405 0 001.987-1.987l-3.367-3.367a1.405 1.405 0 00-1.987 0z"}}),_c('path',{attrs:{"d":"M7.374 8.769L.626 2.02","stroke-linecap":"square"}})])])])
          )
        }
      }
    